/**
 * @generated SignedSource<<4bd90ce18aaa0de93dbf2dab4b41b075>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type HelpObjectStoreArticleSourceSystem = "CONFLUENCE" | "CROSS_SITE_CONFLUENCE" | "EXTERNAL" | "GOOGLE_DRIVE" | "SHAREPOINT" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type articleMetadataFragmentV2$data = {
  readonly ari: string;
  readonly containerName: string;
  readonly displayLink: string;
  readonly sourceSystem: HelpObjectStoreArticleSourceSystem | null | undefined;
  readonly " $fragmentType": "articleMetadataFragmentV2";
};
export type articleMetadataFragmentV2$key = {
  readonly " $data"?: articleMetadataFragmentV2$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleMetadataFragmentV2">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "articleMetadataFragmentV2",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "ari"
    },
    {
      "kind": "ScalarField",
      "name": "displayLink"
    },
    {
      "kind": "ScalarField",
      "name": "containerName"
    },
    {
      "kind": "ScalarField",
      "name": "sourceSystem"
    }
  ],
  "type": "HelpObjectStoreArticleSearchResult"
};

(node as any).hash = "4c3cfc8aeff9894de53a0b5480f56516";

export default node;
